<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Master Data" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <!-- <form> -->
          <div class="row mb-5">
            <div class="col-md-9">
              <FormRow
                v-for="row in leftForm"
                v-bind:key="row.colnum + String(Math.random(1023))"
                :row="row"
                @handleChange="(e) => handleChange(e)"
              />
              <div class="row mt-2">
                <div class="col-md-12">
                  <button
                    type="submit"
                    @click="handleForm"
                    class="btn btn-primary btn-with-icon-left float-right text-uppercase ml-3"
                  >
                    <i class="material-symbols-outlined">check</i>
                    Simpan Kota
                  </button>
                  <!-- <router-link
                    class="btn btn-outline-danger btn-no-outline float-right"
                    to="/master/kota"
                    >Batalkan</router-link
                  > -->
                  <a
                    class="btn btn-outline-danger btn-no-outline float-right text-uppercase"
                    @click="() => goBack('/master/kota')"
                    >Batalkan
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
// import FormGroup from "@/components/FormGroup.vue";
import FormData from "form-data";
// import { HTTP } from "@/config.js";
let data = {
  title: "Kota Baru",
  backBtn: "/master/kota",
  actionBtn: [],
  breadcrumb: [
    { title: "Kota", link: "/master/kota" },
    { title: "Baru", active: true },
  ],
};

export default {
  name: "KotaForm",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    FormRow,
    // FormGroup
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: data,
      leftForm: [
        {
          colnum: 2,
          columns: [
            {
              name: "id_provinsi",
              type: "select",
              label: "Pilih provinsi",
              options: [],
              colwidth: 5,
            },
            { name: "nama", type: "text", label: "Nama Kota", colwidth: 7 },
          ],
        },
      ],
      formSet: {
        id_provinsi: "",
        nama: "",
      },
    };
  },
  methods: {
    goBack(url) {
      if (window.history.length <= 1) {
        this.$router.push({ path: url });
      } else {
        this.$router.go(-1);
      }
    },
    handleForm: async function() {
      //console.log(this.formSet.no_rm);
      this.errors = [];
      let formData = new FormData();
      var self = this;
      let valid = this.validateForm();
      if (valid) {
        Object.keys(this.formSet).forEach(function(key) {
          formData.append(key, self.formSet[key]);
        });
        try {
          let result = await this.$store.state.HTTP.post(
            "wilayah/kota",
            formData
          );
          //console.log(result);
          if (result.status == "200") {
            this.$router.push(`/master/kota`);
          } else {
            //console.log(result.status);
            this.errors.push(result.status);
          }
        } catch (e) {
          //console.log(e);
          this.errors.push(e);
        }
      } else {
        //console.log("tidak valid");
      }
    },
    handleChange(e) {
      this.formSet[e.target.name] = e.target.value;
    },
    fetchProvinsi: async function() {
      try {
        let result = await this.$store.state.HTTP.get("wilayah/provinsi");
        if (result.status == "200") {
          //console.log(result);
          let units = result.data.data.map((item) => {
            item.label = item.nama;
            item.value = item.id;
            return item;
          });
          this.leftForm[0].columns[0].options = units;
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        this.errors.push(e);
      }
    },
    validateForm: function() {
      let valid = true;
      let self = this;
      //console.log(self.formSet);
      this.leftForm = this.leftForm.map(function(row) {
        row.columns = row.columns.map(function(column) {
          if (
            !column.optional &&
            column.type != "hidden" &&
            !self.formSet[column.name]
          ) {
            valid = false;
            column.error = "Kolom ini wajib diisi";
          } else {
            column.error = "";
          }
          column.value = self.formSet[column.name];
          return column;
        });
        return row;
      });
      return valid;
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    this.fetchProvinsi();
  },
};
</script>
